import { CoreModule } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgModule } from '@angular/core';
import { NgbCollapseModule, NgbDatepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { PageModule } from '@abp/ng.components/page';
import { AssetStatusComponent } from './components/asset-status.component';
import { AssetStatusRoutingModule } from './asset-status-routing.module';

@NgModule({
  declarations: [AssetStatusComponent],
  imports: [
    AssetStatusRoutingModule,
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgxValidateCoreModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    PageModule
  ],
})
export class AssetStatusModule {}

export function loadAssetStatusModuleAsChild() {
  return Promise.resolve(AssetStatusModule);
}
